module.exports = __webpack_public_path__ + "media/images/dish-4-f90caa74f92bd5f73fb2e50231a5040d.webp";